/**
 * Build a CSV from headers + rows and trigger a browser download.
 * Each row is joined with commas; cells are stringified as-is (no escaping —
 * callers pass already-safe values).
 */
export function downloadCsv(
	filename: string,
	headers: string[],
	rows: Array<Array<string | number>>,
) {
	const csv = [headers, ...rows].map((r) => r.join(",")).join("\n");
	const blob = new Blob([csv], { type: "text/csv" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}
